import { BellNotification } from 'iconoir-react';
import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from '@savgroup-front-common/core/atoms/Tooltip';
import {
  safeFormattedIntlString,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import { AppIncident } from '@savgroup-front-common/types';

import messages from './messages';
import { $ToastLastUpdate, $ToastLink } from './ToastIncident.styles';

interface ToastIncidentProps {
  incident: AppIncident;
}

const ToastIncident: FunctionComponent<ToastIncidentProps> = ({ incident }) => {
  const intl = useIntl();

  return (
    <>
      {incident.incidentUpdates[0].body}

      <$ToastLastUpdate>
        <SafeFormattedMessageWithoutSpread
          message={messages.lastUpdate}
          values={{
            time: intl.formatDate(incident.updatedAt, {
              day: 'numeric',
              month: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            }),
          }}
        />

        <Tooltip content={safeFormattedIntlString(messages.seemore)}>
          <$ToastLink href={incident.shortlink} isExternal target="_blank">
            <BellNotification />
          </$ToastLink>
        </Tooltip>
      </$ToastLastUpdate>
    </>
  );
};

export default ToastIncident;
